<template>
  <span>
    {{ value }}
  </span>
</template>

<script>
export default {
  name: 'LbTableDefaultColumn',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
